import React from 'react';
import { DropDownBox, DropDownBoxComponentSpacing } from '@apply/components';
import {
    BridgeAppraisalStatusGroupMapper,
    BridgeAppraisalStatusGroupSection,
} from '../../ApplicationsGrid/functions/mappers/bridgeAppraisalStatusGroupMapper';
import { BridgeAppraisalStatusGroupOptions } from '../../ApplicationsGrid/functions/mappers/bridgeAppraisalStatusGroupOptions';

export interface FilterApplicationsDropDownBoxProps {
    selectedGroup?: BridgeAppraisalStatusGroupSection | 'All';
    set_selectedGroup: (value: BridgeAppraisalStatusGroupSection | 'All') => void;
}

export const FilterApplicationsDropDownBox: React.FC<FilterApplicationsDropDownBoxProps> = ({
    selectedGroup,
    set_selectedGroup,
}) => {
    // internal value: null represents "All"
    const filteredOptions = [
        { value: 'All', label: 'All' },
        ...BridgeAppraisalStatusGroupOptions.filter((opt) => opt.value !== BridgeAppraisalStatusGroupMapper.Section.Closed),
    ];

    return (
        <div style={{ display: 'flex' }}>
            <span style={{ paddingRight: '10px', paddingTop: '5px' }}>Appraisal Status:</span>
            <DropDownBox
                id='filterApplicationsDropDownBox'
                width='260'
                height='32px'
                value={selectedGroup}
                dataSource={filteredOptions}
                displayExpr='label'
                valueExpr='value'
                onChange={(e) => set_selectedGroup(e)}
                componentSpacing={DropDownBoxComponentSpacing.None}
            />
        </div>
    );
};
